import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { MedicalSummaryConfigurationHelper } from "@/Patient/Helpers/MedicalSummaryConfigurationHelper";
import { MedicalSummarySections } from "./MedicalSummaryEnum";

import NewIcon from "@/Globals/_images/drag-dots.svg";

interface MedicalSummarySectionItem {
    section: MedicalSummarySections;
    isHidden: boolean;
    isDisabled: boolean;
    onVisibilityChange: (section: MedicalSummarySections) => void;
}

function SummaryDraggableItem(props: MedicalSummarySectionItem): JSX.Element {
    const { getText } = useTranslation();

    return (
        !props.isDisabled
            ? (
                <>
                    <div className="margin-sm-left margin-md-right inline-flex-center">
                        <NewIcon />
                    </div>
                    <span className="section-content">
                        {getText(MedicalSummaryConfigurationHelper.getLabelBySection(props.section))}
                        <div className="text-capitalize margin-auto-left margin-md-right">
                            <a onMouseDown={e => e.stopPropagation()} onClick={() => props.onVisibilityChange(props.section)}>
                                {props.isHidden ? getText("ConfigureSummary_ShowLabel") : getText("ConfigureSummary_HideLabel")}
                            </a>
                        </div>
                    </span>
                </>
            )
            : (
                <div className="margin-sm-left margin-md-right inline-flex-center">
                    {getText(MedicalSummaryConfigurationHelper.getLabelBySection(props.section))}
                </div>
            )
    );
}

export { SummaryDraggableItem };
